import styled, { keyframes } from 'styled-components';
import Icon from 'components/Icon/Icon';
import { LoaderProps } from './Loader.types';
import { fadeIn } from 'style-utils/keyframes';
import { getThemeColor } from 'style-utils/theme/utils/getThemeColor';

export const LoaderContainer = styled.div<
  Pick<LoaderProps, 'viewMode' | 'active'>
>`
  position: relative;

  ${function manageViewMode({ viewMode = 'inline' }): string {
    switch (viewMode) {
      case 'fluid':
        return `
          display: block;
          width: 100%;
        `;
      case 'fullSize':
        return `
            display: block;
            width: 100%;
            height: 100%;
        `;
      case 'absolute':
        return `
          display: block;
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          z-index: 4;
          pointer-events: none;
        `;
      case 'inline':
        return `
          display: inline-block;
        `;
    }
  }};
`;

export const OverlayContainer = styled.div<
  Pick<LoaderProps, 'overlayViewMode' | 'active' | 'animationDelayMs'>
>`
  background: ${getThemeColor('loaderOverlayBg')};
  position: ${({ overlayViewMode }) =>
    overlayViewMode === 'fullscreen' ? 'fixed' : 'absolute'};
  width: 100%;
  height: 100%;
  inset: 0;
  overflow: hidden;
  z-index: ${({ overlayViewMode }) =>
    overlayViewMode === 'fullscreen' ? '999' : '10'};
  animation: ${fadeIn} 200ms linear;
  animation-fill-mode: both;
  animation-direction: ${({ active }) => (active ? 'normal' : 'reverse')};
  animation-delay: ${({ animationDelayMs = 0 }) => `${animationDelayMs}ms`};
`;

export const OverlayIcon = styled.div`
  position: absolute;
  height: 6rem;
  width: 6rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoaderIconWrapper = styled(Icon)`
  animation: ${rotate} 1200ms linear infinite;
`;
